import { jsx as _jsx } from "react/jsx-runtime";
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './Link.module.scss';
import cn from 'classnames';
const Link = ({ text, size, onClick, className, underline, fontFamily }) => {
    return (_jsx(Paragraph, { fontFamily: fontFamily, onClick: onClick, className: cn(styles.element, className, underline && styles['isUnderline']), title: text, size: size }));
};
export default Link;
